import React from 'react'

function Image(props){
    return <img {...props} />
}

export default Image